import {
  UseTokenInfiniteScrollReturn,
  useTokenInfiniteScroll,
} from '../../../../common/hooks/use-token-infinite-scroll';
import { useValidateUsersShallowStore } from '../../../stores/validate-users-store';
import { usePreviewQueryBase } from './use-preview-query-base';

export const usePreviewInfiniteScroll = ({ enabled }: { enabled: boolean }): UseTokenInfiniteScrollReturn => {
  const { filters } = useValidateUsersShallowStore('filters');

  return useTokenInfiniteScroll({
    enabled,
    filterKey: `${filters.searchValue}|${filters.location}`,
    useQuery: usePreviewQueryBase,
  });
};
